import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryTabs from "./components/CategoryTabs";
import LatestNews from "./components/LatestNews";
import StatsSection from "./components/StatsSection";

export default function Home() {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "黑料官网",
    url: window.location.origin,
    description: "黑料官网是专注于收录和分享最新真实黑料内容的权威爆料平台，汇聚海量独家内幕、明星黑料、网红黑料及各类热门事件深度揭秘，第一时间为您呈现最劲爆的真相资讯。",
    potentialAction: {
      "@type": "SearchAction",
      target: `${window.location.origin}/search?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "黑料官网",
    url: window.location.origin,
    description: "国内领先的真实黑料爆料与娱乐资讯聚合平台",
    contactPoint: {
      "@type": "ContactPoint",
      email: "contact@heiliaowang.com",
      contactType: "customer service",
      availableLanguage: "Chinese",
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryTabs />
          <StatsSection />
          <LatestNews />
        </main>
        <Footer />
      </div>
    </>
  );
}